module.exports = __webpack_public_path__ + "static/media/product1.2bdc8744.png";